import { useNavigate } from 'react-router-dom';
import { useUser } from '@/hooks/user-user';
import ReturnUser from './ReturnUser';
import allRoutes, { ProtectedRouteKeys } from '@/lib/routes';

type Props = {
  children: JSX.Element;
  adminRoute?: boolean;
  accessControl?: ProtectedRouteKeys;
};

const ProtectedRoute = ({ children, adminRoute, accessControl }: Props) => {
  const router = useNavigate();
  const {
    isGlobalAdmin,
    isGroupAdmin,
    teamName,
    authStatus,
    loading: userLoading,
    userIsSet,
    accessibleProtectedRoutes,
  } = useUser();
  const userNotAssignedToGroup = userIsSet && !teamName && authStatus === 'authenticated' && !userLoading;
  const hasAdminAcces = isGlobalAdmin || isGroupAdmin;
  const accesDenied = authStatus === 'authenticated' && userIsSet && !userLoading && !teamName && !hasAdminAcces;
  const routeToLogin = authStatus === 'unauthenticated';
  const hasNoAccesTo =
    userIsSet && accessControl && !accessibleProtectedRoutes.includes(allRoutes[accessControl].route);

  if (userNotAssignedToGroup) {
    return (
      <ReturnUser
        counter={10}
        message={'Sie wurden keinem Verein zugewiesen. Bitte kontaktieren Sie den Administrator.'}
      />
    );
  }

  // route only accessible if the user has the required access Attributes or is an admin
  if (hasNoAccesTo) {
    return (
      <ReturnUser
        message={'Sie haben keine Berechtigung für diesen Abschnitt. Bitte kontaktieren Sie den Administrator.'}
        logout={false}
        routeTo="/navigation"
      />
    );
  }

  // if the user is not authenticated, redirect to the login page
  if (accesDenied)
    return (
      <ReturnUser message={'Sie haben keine Berechtigung für diese Seite. Bitte kontaktieren Sie den Administrator.'} />
    );

  // fallback for the first render, to prevent flickering
  if (authStatus === 'configuring' || (adminRoute && userLoading)) return null;

  // if its a admin route and the user is not an admin, render access denied
  if (adminRoute && !hasAdminAcces)
    return (
      <ReturnUser
        message={'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.'}
        logout={false}
        routeTo="/navigation"
      />
    );

  if (routeToLogin) router(allRoutes.login.route);

  return <>{children}</>;
};

export default ProtectedRoute;
